import Show from '../show'

function PrDashboard() {
  return (
    <Show
      title="Payroll Dashboard"
      dashboardKey="pr_dashboards"
    />
  )
}

export default PrDashboard
